// FAQ Accordion
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq-item__question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        var answer = item.querySelector('.faq-item__answer');
        var isOpen = item.classList.contains('open');

        // Close all others in same group
        var parent = item.parentElement;
        if (parent) {
          parent.querySelectorAll('.faq-item.open').forEach(function (openItem) {
            if (openItem !== item) {
              openItem.classList.remove('open');
              var ans = openItem.querySelector('.faq-item__answer');
              if (ans) ans.style.maxHeight = null;
            }
          });
        }

        if (!isOpen) {
          item.classList.add('open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        } else {
          item.classList.remove('open');
          answer.style.maxHeight = null;
        }

        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  });
}());
